import React, { FC } from "react";
import styled from "styled-components";
import { GREEN } from "../styles/constants";
import { opacityHover } from "../styles/atoms";

interface Props {
  value: number;
  add: () => void;
  remove: () => void;
}
const Counter: FC<Props> = ({ value, add, remove }) => {
  return (
    <Wrap>
      <Minus type="button" onClick={remove} />
      <Value>{value}</Value>
      <Plus type="button" onClick={add} />
    </Wrap>
  );
};

const Wrap = styled.div`
  display: inline-flex;
  align-items: center;
`;

const Plus = styled.button`
  position: relative;
  width: 25px;
  height: 25px;
  border: 1px solid ${GREEN};
  border-radius: 5px;
  background: none;
  cursor: pointer;
  ${opacityHover};

  &[disabled] {
    border-color: red;
  }

  &:before,
  &:after {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    display: block;
    width: 15px;
    height: 1px;
    background-color: ${GREEN};
    margin: auto;
    content: "";
  }

  &:after {
    transform: rotate(90deg);
  }
`;

const Minus = styled(Plus)`
  &:after {
    display: none;
  }
`;

const Value = styled.p`
  display: inline-block;
  width: 27px;
  font-size: 16px;
  line-height: 18px;
  text-align: center;
`;

export default Counter;
